import angular from 'angular';

import Component from './time-picker.component';

const Module = angular
    .module('control-room.commons.basic.components.time-picker', [])
    .component('crTimePicker', Component);

export default Module;
